export default __webpack_public_path__ + "static/media/credit.414c4e63.svg";